import React, { Component } from 'react';
import './App.css';

import { ImageFilters } from './config';
import Camera from './components/Camera';
import { saveAs } from 'file-saver';
class App extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.resultImgRef = React.createRef();
    this.state = {
      name: "",
      imagePreview: null,
      cameraImg: null,
      isCameraScreen: false
    };
  }

  componentDidMount() {
    this.elem = document.documentElement;
    const canvas = this.canvasRef.current;
    this.canvasContext = canvas.getContext('2d');
  }

  openFullscreen = () => {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) { /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) { /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
      document.msExitFullscreen();
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    if(this.state.name === ""){
      alert("Please provide a name!");
    } else if(this.state.cameraImg === null){
      alert("No image taken! Please capture your photo!");
    } else {
      saveAs(this.state.cameraImg, this.state.name + ".png");
    }
  }

  onInputChange = (e) => this.setState({ name : e.target.value.trim() })

  onSelectChange = (e) => {
    let filter = ImageFilters.find(el => el.value === e.target.value);
    this.setState({ imagePreview: filter.srcImg});
  }

  takePhoto = () => {
    if (this.state.imagePreview) {
      this.openFullscreen();
      this.setState({ isCameraScreen: true });
    } else {
      alert("Please select filter!");
    }
  }

  goToMainScreen = () => {
    this.setState({ isCameraScreen: false });
    this.closeFullscreen();
  }

  loadImages = (sources, callback) => {

    let images = [];
    let loadedImages = 0;
    let numImages = sources.length;

    for (let i = 0; i < sources.length; i++) {
      images[i] = document.createElement('img');
      images[i].onload = function () {
        if (++loadedImages >= numImages) {
          callback(images);
        }
      };
      images[i].src = sources[i];
    }
  }

  savePhoto = (generatedImg) => {
    // 3:4 ratio
    const width = window.innerWidth ? window.innerWidth : window.screen.width;
    const height = (width/3) * 4;

    this.goToMainScreen();

    let sources = [generatedImg, this.state.imagePreview];

    this.loadImages(sources,(images) => {

      let imageElem = this.resultImgRef.current;

      for (let i = 0; i < sources.length; i++) {
        this.canvasContext.drawImage(images[i], 0, 0, width, height);
      }

      imageElem.src = this.canvasContext.canvas.toDataURL('image/png');
      this.canvasContext.canvas.toBlob( blob => this.setState({cameraImg : blob}) );
    });
  }

  render() {
    const { imagePreview, isCameraScreen, name } = this.state;

    // 3:4 ratio
    const width = window.innerWidth ? window.innerWidth : window.screen.width;
    const height = (width/3) * 4;

    return (
      <div className="App">
        {!isCameraScreen &&
          (<div className="main-screen">
            <header>
              <h1>Crazy Selfies</h1>
            </header>
            <section>
              <form>
                <input type="text" name="Name" value={name} placeholder="Enter your name" onChange={this.onInputChange}/>

                <select name="filters" defaultValue="default" onChange={this.onSelectChange}>
                  <option disabled value="default"> -- Select a filter -- </option>
                  {ImageFilters.map(filter => (<option key={"option-" + filter.value} value={filter.value}>{filter.name}</option>))}
                </select>

                <input type="button" value="Take Photo" name="takephoto" onClick={this.takePhoto} />

                {imagePreview && <img src={imagePreview} ref={this.resultImgRef} alt="Selfie Preview" className="preview" />}

                <canvas
                style={{display : "none"}} 
                width={width}
                height={height}
                ref={this.canvasRef} ></canvas>

                <input type="submit" value="Download" onClick={this.submitForm} />

              </form>
            </section>
          </div>)}
        {isCameraScreen &&
          <Camera
            filterImg={imagePreview}
            closeCamera={this.goToMainScreen}
            savePhoto={this.savePhoto}
          />
        }
      </div>
    );
  }
}

export default App;
